import { Dialog, DialogBackground, QuitButton } from "./style";

export const ModalDialog = ({ children, setModalDialog }) => {
  return (
    <>
      <DialogBackground onClick={() => setModalDialog(null)}>
        <Dialog>
          <QuitButton onClick={() => setModalDialog(null)}>X</QuitButton>
          {children}
        </Dialog>
      </DialogBackground>
    </>
  );
};
